export default class PersonType {
  constructor(obj) {
    obj = obj || {};
    // The parseInt is needed for the v-autocomplete mapping
    this.id = parseInt(obj.id);
    this.description = obj.description;
  }
}